var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 -2048 2055 2048",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    transform: "scale(1, -1)",
    d: "M2048 1713q0 -66 -25 -128t-73 -110l-1317 -1317l-633 -158l158 633l1317 1317q48 48 110 73t128 25q69 0 130 -26.5t106.5 -72t72 -106.5t26.5 -130zM326 620q106 -35 182.5 -111.5t111.5 -182.5l1081 1082l-293 293zM176 176l329 82q-10 46 -32.5 87t-54.5 73t-73 54.5 t-87 32.5zM1792 1499q25 25 48 47t41 46.5t28.5 53t10.5 66.5q0 43 -16.5 80.5t-45 66t-66 45t-80.5 16.5q-38 0 -66.5 -10.5t-53 -28.5t-46.5 -41t-47 -48z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/Edit.2f20065f.svg";
export { ForwardRef as ReactComponent };